import { render, staticRenderFns } from "./LaStoriaAttraversoIReperti.vue?vue&type=template&id=e4ed48c6&scoped=true&"
import script from "./LaStoriaAttraversoIReperti.vue?vue&type=script&lang=js&"
export * from "./LaStoriaAttraversoIReperti.vue?vue&type=script&lang=js&"
import style0 from "./LaStoriaAttraversoIReperti.vue?vue&type=style&index=0&id=e4ed48c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ed48c6",
  null
  
)

export default component.exports